<template>
  <div class="mc-liveview-ico">
    <span>
      <SelectOptions />
      <Legend />
    </span>
  </div>
</template>
<script>
import SelectOptions from './RightButton/SelectOptions'
import Legend from './RightButton/Legend'
export default {
  name: 'RightButton',
  components: {
    SelectOptions,
    Legend,
  },
  methods: {
    back() {
      var self = this
      this.$dialog
        .confirm('Yakin akan kembali?')
        .then(function (dialog) {
          self.$store.commit('sidebar/toggleSideBar')
          self.$store.commit('map/TYPE_OF_MAP', 'fleet')
          dialog.loading(false)
          dialog.close()
        })
        .catch(function (dialog) {
          dialog.loading(false)
          dialog.close()
        })
    },
  },
}
</script>
